import { render, staticRenderFns } from "./TopVideosTable.vue?vue&type=template&id=32f7d9f9&scoped=true&"
import script from "./TopVideosTable.vue?vue&type=script&lang=js&"
export * from "./TopVideosTable.vue?vue&type=script&lang=js&"
import style0 from "./TopVideosTable.vue?vue&type=style&index=0&id=32f7d9f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f7d9f9",
  null
  
)

export default component.exports